import logo from 'images/placeholders/polo-avatar.png';

const context = 'https://schema.org';
const currency= "USD";
const availability= "http://schema.org/InStock";

interface SchemaOrgJSONLD {
  '@context': string;
  '@type': string;
  url: string;
  name: string;
  alternateName: string;
  description?: string;
}

interface Author {
  name: string;
  organization: string;
}

interface PageMetaData {
  uid: string;
  title: string;
  datePosted: string;
  date: string;
  type: string;
  author: Author;
  validityInDays: string;
  monthsOfExperience: number;
  educationRequirements: string[];
  salaryMin: number;
  salaryMax: number;
  remoteEligible: boolean;
  description: string;
  category: string;
  skills: string[];
  image: {
    src: string;
  };
  tags: string[];
  slug: string;
  jobDescriptions: string[];
  perks: string[];
  positionOpen: number;
  keywords: string;
  featuredImage: {
    src: string;
  };
  remoteOnly: boolean;
  vacancyCount: number;
  price?: string;
  sku?: string;
}

interface SiteMetadata {
  title: string;
  siteUrl: string;
  description: string;
}

const getSchemaOrgJSONLD = ({
  siteMetadata,
  pageMetaData,
}: {
  siteMetadata: SiteMetadata;
  pageMetaData: PageMetaData;
}): SchemaOrgJSONLD => {
  const {
    title: siteTitle,
    description: siteDescription,
    siteUrl,
  } = siteMetadata || {};

  const {
    title,
    author,
    description,
    image,
    type,
    slug: url,
    date,
    keywords,
    category,
    price,
    sku,
  } = pageMetaData;

  const isBlogPost = type === 'blog-post';
  const isJobs = type === 'job';

  const isProduct = type === 'template';
  const priceWithoutCurrency = price?.replace(/\$/g, '');
  
  const schemaOrgJSONLD: SchemaOrgJSONLD = {
    '@context': context,
    '@type': 'WebSite',
    url: siteUrl,
    name: title || siteTitle,
    description: description || siteDescription,
    alternateName: siteTitle,
  };

  if (isProduct) {
    return {
      ...schemaOrgJSONLD,
      ...{
        "@context": context,
    "@type": "Product",
    name: title || siteTitle,
    url: `${siteUrl}${url}`,
    image: `${siteUrl}${image}`,
    description: description || siteDescription,
    sku: sku,
    brand: {
      "@type": "Brand",
      name: author,
      logo: {
        '@type': 'ImageObject',
        url: `${siteUrl}${String(logo)}`,
      },
    },
    offers: {
      "@type": "Offer",
      priceCurrency: currency,
      price: priceWithoutCurrency,
      availability: availability,
      url: `${siteUrl}${url}`
    },
      }
   }}

  if (!isBlogPost) return schemaOrgJSONLD;
 

  return {
    ...schemaOrgJSONLD,
    ...{
      '@context': context,
      '@type': 'BlogPosting',
      url,
      name: title,
      alternateName: siteTitle,
      headline: title,
      keywords,
      genre: category,
      image: {
        '@type': 'ImageObject',
        url: image.src,
      },
      description,
      author: {
        '@type': 'Person',
        name: author.name,
      },
      publisher: {
        '@type': 'Organization',
        url: siteUrl,
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}${String(logo)}`,
        },
        name: author.organization,
      },
      mainEntityOfPage: {
        '@type': 'WebSite',
        '@id': siteUrl,
      },
      datePublished: date,
      dateModified: date,
    },
  };
};

export default getSchemaOrgJSONLD;
